<template>
  <div id="visit-reports">
    <!-- Page title -->
    <page-title icon="fa fa-calendar-alt" main="Agenda" sub="Relatórios de Visitas" :help="true"
      titleHelp="Ajuda - Relatório de Visita"
      content="Responsável por listar e editar relatórios de visitas. Para editar um relatório de visita basta clicar em editar na coluna ações."
    />

    <!-- Filers -->
    <schedule-reports-filter 
      v-model="filter" 
      clear-filters
      :loading="loading"
      @clear-filters="clearFilters"
      @search="getScheduleReports" />

    <!-- Report list -->
    <div class="card mt-2" style="padding: 1rem">
      <div slot="header" class="align-items-center">
        <div class="col-sm-12 col-md-12">
          <h5 class="h3 mb-0">Relatórios</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-4">
            Lista de relatórios de visitas:
          </h6>

          <schedule-reports-list
            :schedule-reports="scheduleReports"
            v-loading="loading"
            can-edit
            @action:edit="editScheduleReport"
            @action:export-pdf="exportPdf"
            :loading-export-pdf="loadingScheduleReport"
          />

          <div slot="footer" class="row justify-content-end mr-1 mt-2">
            <base-pagination
              v-model="paginationParams.current"
              @input="changePage"
              :total="paginationParams.total"
              :per-page="paginationParams.per_page"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Report edit modal -->
    <modal
      :show.sync="modals.scheduleReportForm"
      size="lg"
      modal-content-classes=""
      header-classes="pb-2"
      body-classes="pb-0 px-0 pt-0"
      footer-classes="pt-3 flex-column flex-sm-row"
    >
      <template slot="header">
        <div>
          <h5 class="modal-title mb-0" id="exampleModalLabel">
            Relatório de Visita
          </h5>
          <span>
            Cliente:
            {{ formScheduleReport && formScheduleReport.schedule && formScheduleReport.schedule.client.razao_social }}
          </span>
          <br>
          <span>
            Data:
            {{ formScheduleReport && formScheduleReport.schedule && formScheduleReport.schedule.date_start | formatDate }}
          </span>
        </div>
      </template>

      <schedule-report-form v-model="formScheduleReport" />
    </modal>
  </div>
</template>

<script setup>
import Modal from "@/components/Modal";
import { onMounted, ref } from "vue";
import PageTitle from "@/layouts/PageTitle";
import ScheduleReportsFilter from "@/components/ScheduleReports/ScheduleReportFilters";
import ScheduleReportsList from "@/components/ScheduleReports/ScheduleReportList";
import ScheduleReportForm from "@/components/ScheduleReports/ScheduleReportForm";

import axios from "@/backend/axios/index.js";

const modals = ref({
  scheduleReportForm: false,
});

const formScheduleReport = ref({});
const scheduleReports = ref([]);
const filter = ref({});
const currentUser = JSON.parse(localStorage.currentUser);
const loading = ref(false);

const getScheduleReports = async () => {
  loading.value = true;
  try {
    const response = await axios.get("/api/v1/schedule_reports", {
      params: {
        q: {
          ...filter.value,
          salesman_id: currentUser.id,
          since: new Date().toISOString().split("T")[0],
        },
        per_page: paginationParams.value.per_page,
        page: paginationParams.value.page,
      },
    });

    scheduleReports.value = response.data.schedule_reports || [];
    paginationParams.value = response.data.pagination_params || {};
  } catch (error) {
    console.warn("[VisitReports][getScheduleReports]", error);
  }
  loading.value = false;
};

const editScheduleReport = (scheduleReport) => {
  console.log("editScheduleReport", scheduleReport);
  formScheduleReport.value = Object.assign({}, scheduleReport, { schedule_report_items: [] });
  modals.value.scheduleReportForm = true;
};

const loadingScheduleReport = ref(false);
const exportPdf = async (scheduleReport) => {
  loadingScheduleReport.value = true;
  try {
    const response = await axios.get("/api/v1/schedule_reports.pdf", {
      params: {
        q: {
          id: scheduleReport.id,
        }
      },
      responseType: "arraybuffer",
    });

    // Starting file donwload
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank'
    link.setAttribute('download', 'relatorio-de-visita.pdf');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.warn("[VisitReports][getScheduleReports]", error);
  }
  loadingScheduleReport.value = false;
};

// Pagination

const paginationParams = ref({
  page: 1,
  per_page: 10,
  total: 0,
});
const changePage = (page) => {
  paginationParams.value.page = page;
  getScheduleReports();
};
const clearFilters = () => {
  filter.value = {}
};

onMounted(() => {
  getScheduleReports();
});
</script>
